import React, { useEffect, useState } from 'react';
import { Modal, Select, Button, notification } from 'antd';

const { Option, OptGroup } = Select;

const ReassignModal = ({ visible, job, billersList, groupsList, onSubmit, onCancel, loading }) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!visible) setSelected(null);
  }, [visible]);

  const handleOk = () => {
    if (!selected) {
      notification.error({ message: 'Please select a biller or biller group.' });
      return;
    }
    let billerConfig;
    if (selected === 'any') {
      billerConfig = { billers: ['any'], billerGroups: [] };
    } else {
      const [type, id] = selected.split('__');
      billerConfig = type === 'biller'
        ? { billers: [id], billerGroups: [] }
        : { billers: [], billerGroups: [id] };
    }
    onSubmit(job, billerConfig);
  };

  const activeBillers = (billersList || []).filter(b => b.isEnabled);
  const activeGroups = (groupsList || []).filter(g => g.active);

  return (
    <Modal
      title={`Reassign Job ${job?.jobNumber || ''}`}
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
      style={{ top: 200 }}
      footer={[
        <Button key='cancel' onClick={onCancel} style={{ borderRadius: 8 }}>
          Cancel
        </Button>,
        <Button key='ok' type='primary' onClick={handleOk} loading={loading} style={{ borderRadius: 8 }}>
          Reassign
        </Button>
      ]}
    >
      <p style={{ marginBottom: 16, color: '#666', fontSize: 13 }}>
        Currently assigned to{' '}
        <strong>
          {(job?.assignedBiller?.billers || []).map(b => b.fullName).join(', ') ||
            (job?.assignedBiller?.billerGroups || []).map(g => g.groupName).join(', ') ||
            '—'}
        </strong>
      </p>
      <style>{`.reassign-select .ant-select-selector { border-radius: 8px !important; }`}</style>
      <Select
        placeholder='Select new biller or group'
        value={selected}
        onChange={val => setSelected(val)}
        style={{ width: '100%' }}
        className='reassign-select'
        size='large'
        allowClear
        dropdownStyle={{ borderRadius: 8 }}
      >
        <Option value='any'>Any</Option>
        {activeBillers.length > 0 && (
          <OptGroup label='Billers'>
            {activeBillers.map(b => (
              <Option key={`biller-${b.id}`} value={`biller__${b.id}`}>
                {b.fullName}
              </Option>
            ))}
          </OptGroup>
        )}
        {activeGroups.length > 0 && (
          <OptGroup label='Biller Groups'>
            {activeGroups.map(g => (
              <Option key={`group-${g.id}`} value={`group__${g.id}`}>
                {g.groupName}
              </Option>
            ))}
          </OptGroup>
        )}
      </Select>
    </Modal>
  );
};

export default ReassignModal;
